import { Component } from '@angular/core';

@Component({
    selector: 'app-report-view-no-entry',
    templateUrl: './report-view-no-entry.component.html',
    styleUrls: ['./report-view-no-entry.component.scss'],
    standalone: false
})
export class ReportViewNoEntryComponent {}
